module.exports = __webpack_public_path__ + "img/img7.9f29db1d.svg";